import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { News } from '../../interfaces/news.interface';
import { CommonsService } from '../../services/common.service';
import { ScrollPositionService } from '../../services/scroll-position.service';

@Component({
  selector: 'app-news-list-item',
  standalone: false,
  templateUrl: './news-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./news-list-item.component.scss']
})
export class NewsListItemComponent {
  @Input() news!: News;
  @Input() homeView: boolean = false;
  imagesUrl = `${environment.ImagesUrl}/news/`;

  constructor(
    private commonsService: CommonsService,
    private scrollPositionService: ScrollPositionService
  ) { }

  getTimeAgo(created: string): string {
    return this.commonsService.getTimeAgo(created);
  }

  onNewsClick(): void {
    const route = ['/wiadomosci', this.news.title.toLowerCase().replace(/\s+/g, '-'), this.news.id.toString()];
    this.scrollPositionService.navigateWithScrollSave(route, '/wiadomosci', this.news.id.toString());
  }
}
